import React from 'react';

interface JsonLdProps {
  data: Record<string, any>;
}

export const JsonLd: React.FC<JsonLdProps> = ({ data }) => {
  const json = React.useMemo(() => JSON.stringify(data), [data]);
  return (
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: json }} />
  );
};

export default JsonLd;


